export default __webpack_public_path__ + "static/media/python.5a709086.svg";